<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
        <div class="col-md-2">
          <label for="starDate">{{$t('Tarixdən')}}</label>
          <el-date-picker size="small" format="dd.MM.yyyy" id="starDate" type="date" :clearable="false"
            v-model="item.startDate">
          </el-date-picker>
        </div>
        <div class="col-md-2">
          <label for="endDate">{{$t('Tarixədək')}}</label>
          <el-date-picker size="small" format="dd.MM.yyyy" id="endDate" type="date" :clearable="false"
            v-model="item.endDate">
          </el-date-picker>
        </div>
        <div class="col-md-8" style="padding-bottom: 10px">
          <label>{{$t('Axtarış_növü')}}</label>
          <div class="d-flex justify-content-start">
            <div class="d-flex flex-row">
              <el-select style="width: 90%" size="small" v-model="item.searchType">
                <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
                <el-option :label="$t('İş_nömrəsi')" :value="1"></el-option>
                <el-option :label="$t('DQN')" :value="3"></el-option>
                <el-option :label="$t('Məsul_şəxs')" :value="4"></el-option>
                <el-option :label="$t('İştirakçılara_görə')" :value="5"></el-option>
              </el-select>
              &nbsp;
              <el-input size="small" :placeholder="$t('Axtar')" @keyup.enter.native="getData"
                :disabled="item.searchType == 0" v-model="item.searchText">
                <template slot="prepend"> </template>
              </el-input>
              &nbsp;
              <el-button size="small" :title="$t('Axtarış')" type="primary" icon="el-icon-search"
                @click="getData"></el-button>
            </div>
          </div>
        </div>

        <div class="col-md-8 col-12">
          <div class="d-flex justify-content-start">
            <div class="d-flex flex-row">
              <el-checkbox @change="getData" v-model="item.myData">{{$t('Mənim_hadisələrim')}}</el-checkbox>
              <el-checkbox @change="getData" v-model="item.noResponsible">{{$t('Məsul_şəxs_təyin_olunmayıb')}} </el-checkbox>
            </div>
          </div>
        </div>

    </div>

    <div class="row">
      <div class="col-12">
        <el-table v-loading="loading" :data="displayData.filter(
          (data) =>
            !search ||
            data.claimNumber
              .toString()
              .toLowerCase()
              .includes(search.toString().toLowerCase()) ||
            data.participants
              .toString()
              .toLowerCase()
              .includes(search.toString().toLowerCase())
        )
          " style="width: 100%">
          >
          
       <el-table-column :label="$t('İş_#')" sortable prop="dispClaimNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispClaimNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Status')" width="300">
            <template slot-scope="scope">
              <status-label :type="scope.row.statusTypeId === 70
                  ? 'goldenrod'
                  : '' || scope.row.statusTypeId === 75
                    ? 'limeGreen'
                    : '' || scope.row.statusTypeId === 80
                      ? 'mediumBlue'
                      : '' || scope.row.statusTypeId === 95
                        ? 'greenYellow'
                        : '' || scope.row.statusTypeId === 110
                          ? 'coral'
                          : '' || scope.row.statusTypeId === 125
                            ? 'salmon'
                            : '' || scope.row.statusTypeId === 130
                              ? 'olive'
                              : '' || scope.row.statusTypeId === 131
                                ? 'lightblue'
                                : '' || scope.row.statusTypeId === 135
                                  ? 'forestGreen'
                                  : ''
                                    || scope.row.statusTypeId === 135
                                    ? 'greenYellow'
                                    : ''
                " />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('Sığorta_növü')" prop="policyTypeName" width="300">
          </el-table-column>
          <el-table-column label="Rayon " prop="regionName" width="100">
          </el-table-column>

          <el-table-column :label="$t('Zərərvuran')" prop="atFaultRegNumber" width="100">
          </el-table-column>
          <el-table-column :label="$t('Zərər_çəkən')" prop="victimRegNumber" width="100">
          </el-table-column>

          <el-table-column :label="$t('Məsul_şəxs')" prop="techExpertUserName" width="200">
          </el-table-column>

          <el-table-column :label="$t('TM-nə_göndərilib')" width="150">
            <template slot-scope="scope">
              <status-label :type="scope.row.repairCenterStatus === 1 ? 'green' : 'red'" />
              {{ scope.row.repairCenterStatus === 1 ? 'Bəli' : "Xeyr" }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('F4')" width="100">
            <template slot-scope="scope">
              <status-label :type="scope.row.form4Status === 1 ? 'green' : 'red'" />
              {{ scope.row.form4Status === 1 ? 'Var' : "Yoxdur" }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('Başlama_tarixi_/_Gün_sayı')" prop="statusStartDate">
          </el-table-column>
          <el-table-column fixed="right" width="50">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleCommand(scope.row.id)" style="padding: 0 !important">
                <div class="square-icon"> <i class="fa-solid fa-up-right-from-square"></i></div>
              </el-button>
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button @click="handleStatusView(scope.row.accidentId, 'accident')" style="padding: 0 !important">
                <div class="square-icon"> <i :title="$t('Ümumi_Statuslar')" class="fa-solid fa-timeline"></i></div>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="totalRecords">
          </el-pagination>
        </div>
      </div>
    </div>
    <tech-expert-user @refresh-table="getData" ref="user" />
    <accident-status-view ref="status" />
  </div>
</template>

<script>
  import StatusLabel from "../components/StatusLabel.vue";
  import { GetAllClaimsTechExpert } from "src/services/common";
  import TechExpertUser from "./TechExpertUser.vue";
  import { DateToString, AddMonths, AddDays } from "../../services/helper";
  import AccidentStatusView from "../components/AccidentStatusView.vue";
  export default {
    components: {
      StatusLabel,
      TechExpertUser,
      AccidentStatusView
    },
    data() {
      return {
        loading: false,
        data: [],
        totalRecords: 0,
        search: "",
        displayData: [],
        filter: {
          page: 1,
          pagesize: 50,
        },
        val: null,
        uid: this.$store.state.user.id,
        item: {
          startDate: null,
          endDate: null,
          searchType: 0,
          searchText: null,
          myData: false,
          noResponsible: false,
          startExpert: false,
          status: 0,
        },
        cells: {
  'İşin Statusu': 'statusTypeName',
  'İş #': 'claimNumber',
  'Sığorta növü': 'insuranceTypeName',
  'Məsul şəxs / Qiymətləndirici': 'techExpertUserName',
  'Məsul şəxs / Müştəri xidməti': 'clientServiceUserName',
  'Başlama tarixi': 'statusStartDate'
        },
      };
    },
    methods: {
      handleCommand(id) {
        this.handleEdit(id)
      },
      handleEdit(id) {
        let routeData = this.$router.resolve({ path: "../claim/" + id });
        window.open(routeData.href, "_blank");
      },
      handleStatusView(id, type) {
        this.$refs["status"].view(id, type);
      },
      clickSearch() {
        this.filter.page = 1;
        this.getData();
      },

      loadTime() {
        this.item.startDate = AddMonths(new Date(), -6);
        this.item.endDate = AddDays(new Date(), +1);
      },
      getData() {
        this.loading = true;

        const params = {
          startDate: DateToString(this.item.startDate),
          endDate: DateToString(this.item.endDate),
          searchType: this.item.searchType,
          searchText: this.item.searchText || '',
          myData: this.item.myData,
          noResponsible: this.item.noResponsible,
          startExpert: this.item.startExpert,
          status: this.item.status,
          commandUserId: this.uid,
          pageNumber: this.filter.page,
          pageSize: this.filter.pagesize
        };
        GetAllClaimsTechExpert(params).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.data = response.data.data;
            this.totalRecords = response.data.data?.[0].totalRecords;
            this.displayData = this.data;
          }
        });
      },
      handleCurrentChange(val) {
        this.filter.page = val;
        this.getData();
      },
      handleSizeChange(val) {
        this.filter.pagesize = val;
        this.getData();
      },
    },
    mounted() {
      this.loadTime();
      this.getData();
    },
  };
</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
</style>